import { useState, createContext, useContext, ReactNode } from "react";

interface AccordionContextProps {
  openIndex: number | null;
  openStates: Record<number, boolean>;
  handleToggle: (index: number) => void;
  isExclusive: boolean;
}

const AccordionContext = createContext<AccordionContextProps | undefined>(undefined);

interface AccordionGroupProps {
  children: ReactNode;
  isExclusive?: boolean; // true: 아코디언 1개만 오픈 가능, false: 아코디언 여러개 동시 오픈 가능
}

export const AccordionGroup = ({ children, isExclusive = true }: AccordionGroupProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [openStates, setOpenStates] = useState<Record<number, boolean>>({});

  const handleToggle = (index: number) => {
    if (isExclusive) {
      setOpenIndex(openIndex === index ? null : index);
    } else {
      setOpenStates((prev) => ({ ...prev, [index]: !prev[index] }));
    }
  };

  return (
    <AccordionContext.Provider value={{ openIndex, openStates, handleToggle, isExclusive }}>
      <div>
        {children}
      </div>
    </AccordionContext.Provider>
  );
};

interface AccordionProps {
  index: number;
  children: (props: { isOpen: boolean; toggleOpen: () => void }) => ReactNode;
}

export const Accordion = ({ index, children }: AccordionProps) => {
  const context = useContext(AccordionContext);
  const { openIndex, openStates, handleToggle, isExclusive } = context;
  const isOpen = isExclusive ? openIndex === index : openStates[index];

  return (
    <div>
      {children({ isOpen, toggleOpen: () => handleToggle(index) })}
    </div>
  );
};

interface AccordionSummaryProps {
  children: ReactNode;
  onClick: () => void;
  isOpen: boolean;
  isShowChevron?: boolean; // 기본 화살표 UI 표시 여부
}

export const AccordionSummary = ({ children, onClick, isOpen, isShowChevron = true }: AccordionSummaryProps) => {
  return (
    <div onClick={onClick}>
      <div>{children}</div>
      {/* {isOpen ? 'up' : 'down'} */}
    </div>
  );
};

interface AccordionDetailProps {
  children: ReactNode;
  isOpen: boolean;
}

export const AccordionDetail = ({ children, isOpen }: AccordionDetailProps) => {
  return isOpen ? <div>{children}</div> : null;
};